export default __webpack_public_path__ + "static/media/bow.3228aa80.mp4";